// Per-device workout preferences (recovery timer sound + vibration). Default ON.
const SOUND_KEY = 'regen_workout_sound';
const VIB_KEY = 'regen_workout_vibration';

export const getSoundPref = () => localStorage.getItem(SOUND_KEY) !== 'off';
export const getVibrationPref = () => localStorage.getItem(VIB_KEY) !== 'off';
export const setSoundPref = (on) => localStorage.setItem(SOUND_KEY, on ? 'on' : 'off');
export const setVibrationPref = (on) => localStorage.setItem(VIB_KEY, on ? 'on' : 'off');

let _ctx = null;
function ctx() {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!_ctx) _ctx = new AC();
  if (_ctx.state === 'suspended') _ctx.resume();
  return _ctx;
}

// A single tone. `type` square/triangle cut through gym noise better than sine.
function tone(c, freq, when, dur, vol, type = 'square') {
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.value = freq;
  o.connect(g);
  g.connect(c.destination);
  g.gain.setValueAtTime(0.0001, when);
  g.gain.exponentialRampToValueAtTime(vol, when + 0.015);
  g.gain.exponentialRampToValueAtTime(0.0001, when + dur);
  o.start(when);
  o.stop(when + dur + 0.02);
}

// Loud, piercing tick for each of the final 5 countdown seconds (audible without headphones).
export function playTick() {
  if (!getSoundPref()) return;
  const c = ctx();
  if (!c) return;
  tone(c, 1000, c.currentTime, 0.11, 0.6, 'square');
  if (getVibrationPref()) { try { navigator.vibrate?.(50); } catch { /* unsupported */ } }
}

// Distinct, stronger completion cue at 00:00 — a rising 3-note fanfare + a long vibration so it is
// clearly different from the individual countdown beeps.
export function playRecoveryEndCue() {
  if (getSoundPref()) {
    const c = ctx();
    if (c) {
      const t = c.currentTime;
      tone(c, 784, t, 0.16, 0.7, 'square');          // G5
      tone(c, 1047, t + 0.16, 0.16, 0.7, 'square');   // C6
      tone(c, 1319, t + 0.32, 0.30, 0.75, 'triangle'); // E6 (longer, brighter finish)
    }
  }
  if (getVibrationPref()) {
    try { navigator.vibrate?.([250, 120, 400]); } catch { /* unsupported */ }
  }
}
